"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var Wrap = _styled.default.div(function (_ref) {
  var colors = _ref.theme.colors;
  return {
    position: 'relative',
    borderRadius: '50%',
    backgroundColor: colors.error,
    border: "1px solid ".concat(colors.white),
    color: colors.white,
    width: '1.6rem',
    height: '1.6rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.2rem'
  };
});

var _default = Wrap;
exports.default = _default;